export default "__VITE_ASSET__f02b7052__"